jQuery(document).ready(function($) {

	var terms = 'By submitting an enquiry via this contact form, you give permission to First Investment Group to use your data in accordance with our <a href="/privacy-policy/" target="_blank">privacy policy</a>, for the purpose of fulfilling your request and providing you with our services.';
    
	$('.wpforms-submit-container').before('<p class="form-terms">' + terms + '</p>');
 
});